import React from "react";

const Producto = ({ promocion }) => {
  if (Object.keys(promocion) === null) return null;

  return (
    <>
      <div className="card mb-3" style={{ maxWidth: 540 }}>
        <div className="row no-gutters">
          <div className="col-md-4">
            <img src={promocion.images} className="card-img-top" alt="..." />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h5 className="card-title">{promocion.titulo}</h5>
              <p className="card-text">{promocion.descripcion}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Producto;
